import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tracker from "./tracker/Tracker";
import TrackerImportData from "../TimerImportData/trackerImportData/TrackerImportData";
import TrackerImportDataCalendar from "../TimerImportData/trackerImportData/TrackerImportDataCalendar";
function Timer() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isImportData, setIsImportData] = useState(false);
  
  useEffect(() => {
    // Check if coming from calendar import
    if (location.state?.fromCalendar) {
      setIsImportData(true);
    }
  }, [location.state?.fromCalendar]);

  const viewIsImportData = () => {
    setIsImportData(true);
  };

  const isFromCalendar = location.state?.fromCalendar || false;
  
  const handleCancelImportData = () => {
    setIsImportData(false);
    // Clear location state to prevent showing import view on refresh
    window.history.replaceState({}, document.title, window.location.pathname);
    // Redirect to calendar only if coming from calendar
    if (isFromCalendar) {
      navigate('/user/calendar');
    }
  };
  const initialDateRange = location.state?.dateRange || null;
  
  return (
    <>
      {isImportData ? (
        isFromCalendar ? (
          <TrackerImportDataCalendar 
            onCancel={handleCancelImportData} 
            isFromCalendar={isFromCalendar}
            initialDateRange={initialDateRange}
          />
        ) : (
          <TrackerImportData 
            onCancel={handleCancelImportData} 
            isFromCalendar={isFromCalendar}
          />
        )
      ) : (
        <Tracker viewIsImport={viewIsImportData} />
      )}
    </>
  );
}

export default Timer;